import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { company } from '../data/company';
export function FloatingActions() {
  const {
    t
  } = useLanguage();
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-3 sm:bottom-6 sm:right-6" data-id="element-28" data-mp="efb6zicu71sn">
      <AnimatePresence data-id="element-29" data-mp="jc1li18ztpby">
        {showTop && <motion.button type="button" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} aria-label={t('cta.backToTop')} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-navy/15 bg-white text-navy shadow-md transition-colors duration-150 ease-smooth hover:border-brand-700 hover:text-brand-700" data-id="element-30" data-mp="2g5mlmvp7wgme">
            <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="z1ghqw1g0wdd" />
          </motion.button>}
      </AnimatePresence>

      <a href={company.phoneHref} aria-label={`${t('cta.call')} ${company.phone}`} className="inline-flex items-center justify-center rounded-full bg-brand-700 p-3.5 text-white shadow-lg transition-colors duration-150 ease-smooth hover:bg-brand-800" data-id="element-32" data-mp="u358amf28nvo">
        <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-33" data-mp="3aqr7rzpz4kxt" />
      </a>

      <a href={company.whatsappHref} target="_blank" rel="noreferrer noopener" aria-label={t('cta.whatsapp')} className="inline-flex items-center justify-center rounded-full bg-[#1FA855] p-3.5 text-white shadow-lg transition-colors duration-150 ease-smooth hover:bg-[#188443]" data-id="element-34" data-mp="35rebkod7q1ik">
        <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-35" data-mp="2y8n6mf1ivnci" />
      </a>
    </div>;
}